import message from "./message";
import user from "./user";

export default [message, user];
